import Header from "./components/Header";
import { Routes, Route } from "react-router-dom";
import Blogs from "./pages/Blogs";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Subscribers from "./pages/Subscribers";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CreateBlog from "./components/CreateBlog";
import Blog from './components/Blog';
import BlogDetails from './components/EditBlogDetails';
import { Toaster } from "react-hot-toast";
import { Navigate } from "react-router-dom";

function App() {
  return (
    <>
      <Header />
      <Toaster />
      <Routes>
        <Route path="/" element={< Home />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/About" element={<About />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        {/* <Route path="/blog/:id" element={<Blog />} /> */}
        <Route path="/blog/:blogUrl" element={<Blog />} />
        <Route path="/blog-details/:id" element={<BlogDetails />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/create-blog"
          element={localStorage.getItem("userId")
            ? <CreateBlog />
            : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/subscribers"
          element={localStorage.getItem("userId")
            ? <Subscribers />
            : <Navigate to="/login" replace />
          }
        />
      </Routes>
    </>
  );
}
export default App;